<template>
  <div v-if="activity">
    <h5>{{ activity.name }}</h5>
    <VariantSelector :activity="activity"
                      v-model="variant"
                      :parent-options="parentOptions"
    ></VariantSelector>
    <template v-if="variant">
      <VariantInformation
                          :activity="activity"
                          :variant="variant"
                          :order-item-price="orderItemPrice"
                          :order-item-initial-price="orderItemInitialPrice"
                          :update-price="activityHasChanged"
                          @price-change="orderItemPrice = $event"
      ></VariantInformation>
    </template>
    <Alert v-else variant="info">
      {{ $t('No variant selected') }}
    </Alert>
  </div>
</template>

<script setup>
import VariantSelector from "@/components/orders/VariantSelector.vue";
import VariantInformation from "@/components/orders/VariantInformation.vue";
import Alert from "@/components/ui/Alert.vue";
import { computed, watch, ref } from "vue";

const props = defineProps({
  associatedActivity: {
    type: Object,
    required: true
  },
  parentOptions : {
    type: Object,
    required: true
  },
})

const activity = computed(() => {
  return props.associatedActivity.activity;
})

const variant = ref(props.associatedActivity.variant)
const orderItemPrice = ref(props.associatedActivity.orderItemPrice ? props.associatedActivity.orderItemPrice : props.associatedActivity.activity.price)
const orderItemInitialPrice = ref(props.associatedActivity ? ( props.associatedActivity.orderItemPrice ? props.associatedActivity.orderItemPrice : props.associatedActivity.activity.price) : null)
const activityHasChanged = ref(false)

const emit = defineEmits([
  'update-variant'
]);

const updateVariant = () => {
  emit('update-variant', {
    ...props.associatedActivity,
    variant: variant.value,
    orderItemPrice : orderItemPrice.value,
  });
}

watch(
  [() => variant.value, () => orderItemPrice.value],
  () => {
    updateVariant()
    activityHasChanged.value = true
  }
)

</script>
